import React, { useEffect, useState } from "react";
import Chart, {
    ArgumentAxis,
    ValueAxis,
    Series,
    Export,
    Tooltip,
    Legend,
    CommonSeriesSettings
} from 'devextreme-react/chart';
import DateFilter from '@common-components/date-filter/DateFilter';
import DateRange from '@common-components/date-range/DateRange';
import { Button } from 'devextreme-react/button';
import { useFetch } from "@hooks/useStatApi";
import STATISTICS_API from "api/statisticsApi";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Popup } from 'devextreme-react/popup'; // Import Popup for modal



function StandardBarVolume({ batchNo, type = {}, supplierId: supplierIdProp,  batchId = {}, eDate, sDate, filter }) {
    const today = dayjs().startOf('day');
    const oneWeekAgo = today.subtract(1, 'week');
    const supplierId =  supplierIdProp || localStorage.getItem('supplierId');
    const shouldFetch = supplierId !== null; // will be null initially, but maybe undefined is also meaningful
    const [mFilter, setMfilter] = useState()
    const [isModalVisible, setIsModalVisible] = useState(false); // State to control modal visibility

    const [dateRange, setDateRange] = useState(eDate ? `${sDate} - ${eDate}` : `${oneWeekAgo.format('YYYY-MM-DD')} - ${today.format('YYYY-MM-DD')}`);
    const [selectedFilter, setSelectedFilter] = useState(filter ? filter : '1W');
    const batchID = useSelector((state) => state.overview.batchId);
    const handleRedirect = () => {
        setIsModalVisible(true); // Show the modal instead of opening a new tab
    };

    const closeModal = () => {
        setIsModalVisible(false); // Close the modal
    };
    const [startDate, endDate] = dateRange
        ? dateRange.split(' - ').map(date => dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD'))
        : [null, null];
    const params = {

        startDate,
        endDate,
        supplierId,
    };

    const { data: weight, loading: isWeightLoadin, refetch } = useFetch(
        "fetchVolume",
        STATISTICS_API.getWeightStats,
        (!batchNo && shouldFetch) ? params : null

    );

    const { data: weightBatch, loading: isWeightBatchLoading, } = useFetch(
        "fetchVolumeBatch",
        STATISTICS_API.getWeightStatsByBatch,
        batchNo ? { batchNo, startDate, endDate } : null

    );


    const handleQuickFilter = (filter) => {
        setSelectedFilter(filter);
        setMfilter(filter)
        const today = dayjs().startOf('day'); // Ensure it starts from today

        let fromDate = today.format('YYYY-MM-DD'); // Default to today
        switch (filter) {
            case '1W': fromDate = today.subtract(1, 'week').format('YYYY-MM-DD'); break;
            case '1M': fromDate = today.subtract(1, 'month').format('YYYY-MM-DD'); break;
            case '1Q': fromDate = today.subtract(3, 'month').format('YYYY-MM-DD'); break;
            case '1Y': fromDate = today.subtract(1, 'year').format('YYYY-MM-DD'); break;
            case '2Y': fromDate = today.subtract(2, 'year').format('YYYY-MM-DD'); break;
            default: break;
          }

        console.log(`Filter: ${filter}, From: ${fromDate}, To: ${today.format('YYYY-MM-DD')}`);
        setDateRange(`${fromDate} - ${today.format('YYYY-MM-DD')}`);
    };
    useEffect(() => {
        if (dateRange) refetch();
    }, [dateRange, refetch]);

    console.log("weightBatch", weightBatch);


    const chartData = weightBatch?.data?.length > 0 ? weightBatch?.data : weight?.data;

    return (
        <>
            <div className="lg:flex flex-col lg:flex-row space-y-3 lg:space-y-0 items-center justify-between gap-4 mb-4">
                <div>
                    <p className="mb-0 text-xl font-medium">Volume</p>
                </div>
                <div>
                    <DateFilter mFilter={mFilter} onFilterChange={handleQuickFilter} selectedFilter={selectedFilter} />
                </div>
                <div className="flex justify-between items-center">
                    <DateRange onDateChange={(newRange) => {
                        setDateRange(newRange);
                        setSelectedFilter(null); // <--- RESET selectedFilter
                    }} dateRange={dateRange} />

                    {
                        type != "full" ?
                            <Button onClick={handleRedirect} className="ms-2"
                                icon="fullscreen"
                            />
                            : null}
                </div>
            </div>
            <>
                {/* filters */}
                {chartData?.length > 0 ? (
                    <Chart dataSource={chartData}>
                        <CommonSeriesSettings type="bar" barPadding={0.4} />
                        <ArgumentAxis
                            title="Fillet Weight [kg]"
                            tickInterval={1}
                            label={{ overlappingBehavior: 'rotate', rotationAngle: -45 }}
                        />
                        <ValueAxis title="Percentage" />
                        <Series
                            argumentField="weightRangeLabel"
                            valueField="percentage"
                            type="bar"
                            name="Data"
                        />

                        <Tooltip enabled />
                        <Tooltip
                            enabled
                            customizeTooltip={(pointInfo) => ({
                                text: ` ${pointInfo.valueText}%`
                            })}
                        />
                        <Legend visible={false} />
                        <Export enabled={true} formats={['PNG', 'PDF', 'SVG']} fileName="Size-chart" />

                    </Chart>
                ) : (
                    <div className="flex justify-center items-center h-96">
                        <p className="no-data-text">No Data Found</p>
                    </div>
                )}
            </>

            <Popup
        visible={isModalVisible}
        onHiding={closeModal}
        dragEnabled={true}
        closeOnOutsideClick={true}
        showTitle={true}
        title="Volume"
        width="90%"
        height="90%"
      >
        <div className="custom-graphs">
         <div className="lg:flex flex-col lg:flex-row space-y-3 lg:space-y-0 items-center justify-between gap-4">
            <div>
              <DateFilter
                mFilter={mFilter}
                onFilterChange={handleQuickFilter}
                selectedFilter={selectedFilter}
              />
            </div>
            <div>
              <DateRange
                onDateChange={(newRange) => {
                  setDateRange(newRange);
                  setSelectedFilter(null); // Reset selectedFilter
                }}
                dateRange={dateRange}
              />
            </div>
          </div>
         {chartData?.length > 0 ? (
                    <Chart dataSource={chartData} height={600}>
                        <CommonSeriesSettings type="bar" barPadding={0.4} />
                        <ArgumentAxis
                            title="Fillet Weight [kg]"
                            tickInterval={1}
                            label={{ overlappingBehavior: 'rotate', rotationAngle: -45 }}
                        />
                        <ValueAxis title="Percentage" />
                        <Series
                            argumentField="weightRangeLabel"
                            valueField="percentage"
                            type="bar"
                            name="Data"
                        />

                        <Tooltip enabled />
                        <Tooltip
                            enabled
                            customizeTooltip={(pointInfo) => ({
                                text: ` ${pointInfo.valueText}%`
                            })}
                        />
                        <Legend visible={false} />
                                    <Export enabled={true} formats={['PNG', 'PDF', 'SVG']} fileName="Size-chart" />
                        
                    </Chart>
                ) : (
                    <div className="flex justify-center items-center h-96">
                        <p className="no-data-text">No Data Found</p>
                    </div>
                )}
          </div>
        </Popup>

        </>
    );
};

export default StandardBarVolume;
